import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Unknown: { input: unknown; output: unknown; }
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  postal?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type Answer = {
  __typename?: 'Answer';
  blocklistValue?: Maybe<Array<Scalars['JSONObject']['output']>>;
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  booleanlistValue?: Maybe<Array<Scalars['Boolean']['output']>>;
  numericValue?: Maybe<Scalars['Float']['output']>;
  numericlistValue?: Maybe<Array<Scalars['Float']['output']>>;
  textValue?: Maybe<Scalars['String']['output']>;
  textlistValue?: Maybe<Array<Scalars['String']['output']>>;
};

export type AnswerInput = {
  blocklistValue?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  booleanlistValue?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  numericValue?: InputMaybe<Scalars['Float']['input']>;
  numericlistValue?: InputMaybe<Array<Scalars['Float']['input']>>;
  textValue?: InputMaybe<Scalars['String']['input']>;
  textlistValue?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum AuthMode {
  LegacyTenant = 'LEGACY_TENANT',
  SaasOrganization = 'SAAS_ORGANIZATION'
}

export type Category = Node & {
  __typename?: 'Category';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Category>;
};

export type CloudinaryUploadSignature = {
  __typename?: 'CloudinaryUploadSignature';
  public_id: Scalars['String']['output'];
  signature: Scalars['String']['output'];
  timestamp: Scalars['Int']['output'];
};

export type Company = Node & SanityDocument & {
  __typename?: 'Company';
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CompanyConnection = Connection & {
  __typename?: 'CompanyConnection';
  edges?: Maybe<Array<CompanyEdge>>;
  pageInfo: PageInfo;
};

export type CompanyEdge = Edge & {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node: Company;
};

export type CompleteOtpLoginResponse = {
  __typename?: 'CompleteOtpLoginResponse';
  cookies?: Maybe<Array<CookieValue>>;
  success: Scalars['Boolean']['output'];
};

export type Connection = {
  edges?: Maybe<Array<Edge>>;
  pageInfo: PageInfo;
};

export type Context = Node & {
  __typename?: 'Context';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CookieValue = {
  __typename?: 'CookieValue';
  expires?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  sameSite?: Maybe<Scalars['String']['output']>;
  secure?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
};

export type CookieValueInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  expires?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  path?: InputMaybe<Scalars['String']['input']>;
  sameSite?: InputMaybe<Scalars['String']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  auth0_region: Scalars['String']['input'];
  auth0_tenant: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<SanityImageInput>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  organizationManagerEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationManagerUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Edge = {
  cursor: Scalars['String']['output'];
  node: Node;
};

export enum ErrorCodes {
  AuthCodeInvalidOrExpired = 'AUTH_CODE_INVALID_OR_EXPIRED',
  AuthRequestFailed = 'AUTH_REQUEST_FAILED',
  BadRequest = 'BAD_REQUEST',
  CategoryAlreadyExists = 'CATEGORY_ALREADY_EXISTS',
  CategoryCouldNotBeUpdated = 'CATEGORY_COULD_NOT_BE_UPDATED',
  CategoryCreationFailed = 'CATEGORY_CREATION_FAILED',
  CategoryFetchFailed = 'CATEGORY_FETCH_FAILED',
  CategoryNotFound = 'CATEGORY_NOT_FOUND',
  CompanyAlreadyExists = 'COMPANY_ALREADY_EXISTS',
  CompanyCouldNotBeUpdated = 'COMPANY_COULD_NOT_BE_UPDATED',
  CompanyCreationFailed = 'COMPANY_CREATION_FAILED',
  CompanyFetchFailed = 'COMPANY_FETCH_FAILED',
  CompanyNotFound = 'COMPANY_NOT_FOUND',
  ContentLockedByLiveSessionCreateNewItemInstead = 'CONTENT_LOCKED_BY_LIVE_SESSION_CREATE_NEW_ITEM_INSTEAD',
  EmailAlreadyExists = 'EMAIL_ALREADY_EXISTS',
  EvaluationAlreadyExists = 'EVALUATION_ALREADY_EXISTS',
  EvaluationCouldNotBeUpdated = 'EVALUATION_COULD_NOT_BE_UPDATED',
  EvaluationCreationFailed = 'EVALUATION_CREATION_FAILED',
  EvaluationFetchFailed = 'EVALUATION_FETCH_FAILED',
  EvaluationNotFound = 'EVALUATION_NOT_FOUND',
  FailedToUnarchiveParticipant = 'FAILED_TO_UNARCHIVE_PARTICIPANT',
  Forbidden = 'FORBIDDEN',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidCategoryParent = 'INVALID_CATEGORY_PARENT',
  LocationAlreadyExists = 'LOCATION_ALREADY_EXISTS',
  LocationCouldNotBeUpdated = 'LOCATION_COULD_NOT_BE_UPDATED',
  LocationCreationFailed = 'LOCATION_CREATION_FAILED',
  LocationFetchFailed = 'LOCATION_FETCH_FAILED',
  LocationNotFound = 'LOCATION_NOT_FOUND',
  NotFound = 'NOT_FOUND',
  ObjectReferenced = 'OBJECT_REFERENCED',
  OrganizationCreationFailed = 'ORGANIZATION_CREATION_FAILED',
  OrganizationNeedsAuth0Id = 'ORGANIZATION_NEEDS_AUTH0_ID',
  OrganizationNotFound = 'ORGANIZATION_NOT_FOUND',
  ParticipantAlreadyExists = 'PARTICIPANT_ALREADY_EXISTS',
  ParticipantCreationFailed = 'PARTICIPANT_CREATION_FAILED',
  ParticipantFetchFailed = 'PARTICIPANT_FETCH_FAILED',
  ParticipantNotFound = 'PARTICIPANT_NOT_FOUND',
  ParticipantNotReady = 'PARTICIPANT_NOT_READY',
  PlanUpgradeRequired = 'PLAN_UPGRADE_REQUIRED',
  QuestionAlreadyExists = 'QUESTION_ALREADY_EXISTS',
  QuestionCouldNotBeUpdated = 'QUESTION_COULD_NOT_BE_UPDATED',
  QuestionCreationFailed = 'QUESTION_CREATION_FAILED',
  QuestionFetchFailed = 'QUESTION_FETCH_FAILED',
  QuestionNotFound = 'QUESTION_NOT_FOUND',
  ReportCouldNotBeUpdated = 'REPORT_COULD_NOT_BE_UPDATED',
  ReportCreationFailed = 'REPORT_CREATION_FAILED',
  ReportFetchFailed = 'REPORT_FETCH_FAILED',
  ReportNotFound = 'REPORT_NOT_FOUND',
  ScheduledSessionAlreadyExists = 'SCHEDULED_SESSION_ALREADY_EXISTS',
  ScheduledSessionCouldNotBeUpdated = 'SCHEDULED_SESSION_COULD_NOT_BE_UPDATED',
  ScheduledSessionCreationFailed = 'SCHEDULED_SESSION_CREATION_FAILED',
  ScheduledSessionFetchFailed = 'SCHEDULED_SESSION_FETCH_FAILED',
  ScheduledSessionNotFound = 'SCHEDULED_SESSION_NOT_FOUND',
  SessionAlreadyExists = 'SESSION_ALREADY_EXISTS',
  SessionCouldNotBeUpdated = 'SESSION_COULD_NOT_BE_UPDATED',
  SessionCreationFailed = 'SESSION_CREATION_FAILED',
  SessionFetchFailed = 'SESSION_FETCH_FAILED',
  SessionNotFound = 'SESSION_NOT_FOUND',
  SubscriptionExpired = 'SUBSCRIPTION_EXPIRED',
  SubscriptionInactive = 'SUBSCRIPTION_INACTIVE',
  SubscriptionLimitReached = 'SUBSCRIPTION_LIMIT_REACHED',
  SupplyobjectAlreadyExists = 'SUPPLYOBJECT_ALREADY_EXISTS',
  SupplyobjectCouldNotBeUpdated = 'SUPPLYOBJECT_COULD_NOT_BE_UPDATED',
  SupplyobjectCreationFailed = 'SUPPLYOBJECT_CREATION_FAILED',
  SupplyobjectFetchFailed = 'SUPPLYOBJECT_FETCH_FAILED',
  SupplyobjectNotFound = 'SUPPLYOBJECT_NOT_FOUND',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  TrialLimitReached = 'TRIAL_LIMIT_REACHED',
  Unauthorized = 'UNAUTHORIZED',
  UserNotFound = 'USER_NOT_FOUND'
}

export type Evaluation = Node & {
  __typename?: 'Evaluation';
  _id: Scalars['ID']['output'];
  categories?: Maybe<Array<SanityBaseRef>>;
  context?: Maybe<SanityBaseRef>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<EvaluationOptions>;
  questions?: Maybe<Array<SanityBaseRef>>;
  rCategories?: Maybe<Array<Category>>;
  rContext?: Maybe<Context>;
  rQuestions?: Maybe<Array<Question>>;
  totalMaxTime?: Maybe<Scalars['Int']['output']>;
};

export type EvaluationOptions = {
  __typename?: 'EvaluationOptions';
  enableTimer?: Maybe<Scalars['Boolean']['output']>;
};

export type Location = Node & {
  __typename?: 'Location';
  _id: Scalars['ID']['output'];
  address?: Maybe<Address>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  answerEvaluationQuestionStep?: Maybe<ScheduledSessionParticipantEntry>;
  applyCookie?: Maybe<Scalars['JSON']['output']>;
  completeAndCloseQuestionOrEvaluation?: Maybe<ScheduledSessionParticipantEntry>;
  completeOtpLogin?: Maybe<CompleteOtpLoginResponse>;
  completeSessionReportLogin?: Maybe<SessionReport>;
  /** @deprecated No longer supported */
  continueSession?: Maybe<ScheduledSessionParticipantEntry>;
  createOrganization?: Maybe<Organization>;
  getRealtimeToken?: Maybe<RealtimeToken>;
  logout: LogoutResponse;
  readyScheduledSession?: Maybe<ScheduledSessionParticipantEntry>;
  requestCloudinaryUploadSignature?: Maybe<CloudinaryUploadSignature>;
  requestHelp?: Maybe<ScheduledSessionParticipantEntry>;
  requestLogin?: Maybe<Scalars['Boolean']['output']>;
  sendErrorReport: SendErrorReportResponse;
  signupForScheduledSession?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAnswerEvaluationQuestionStepArgs = {
  answer: AnswerInput;
  evaluation: Scalars['ID']['input'];
  question: Scalars['ID']['input'];
  stepIndex: Scalars['Int']['input'];
};


export type MutationApplyCookieArgs = {
  cookie?: InputMaybe<CookieValueInput>;
};


export type MutationCompleteAndCloseQuestionOrEvaluationArgs = {
  evaluation: Scalars['ID']['input'];
  question?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCompleteOtpLoginArgs = {
  loginCode: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
};


export type MutationCompleteSessionReportLoginArgs = {
  accessCode: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationContinueSessionArgs = {
  evaluation?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationGetRealtimeTokenArgs = {
  scheduledSession?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRequestHelpArgs = {
  evaluation?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRequestLoginArgs = {
  loginCode: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
};


export type MutationSendErrorReportArgs = {
  input: SendErrorReportInput;
};


export type MutationSignupForScheduledSessionArgs = {
  loginCode: Scalars['String']['input'];
  participant: SignupParticipantInput;
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
};

export type Node = {
  _id: Scalars['ID']['output'];
};

export type Organization = SanityDocument & {
  __typename?: 'Organization';
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
  auth0_region: Scalars['String']['output'];
  auth0_tenant: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<SanityImage>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['String']['output']>;
  organizationManagerEmails?: Maybe<Array<Scalars['String']['output']>>;
  organizationManagerUsers?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  pageSize?: Maybe<Scalars['Int']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Participant = Node & {
  __typename?: 'Participant';
  _id: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export enum ParticipantSessionStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  HelpRequested = 'HELP_REQUESTED',
  Paused = 'PAUSED',
  Waiting = 'WAITING'
}

export type Query = {
  __typename?: 'Query';
  allCompanies: CompanyConnection;
  myScheduledSession?: Maybe<ScheduledSession>;
  myScheduledSessionParticipantEntry?: Maybe<ScheduledSessionParticipantEntry>;
  organizationTenantExists?: Maybe<Scalars['Boolean']['output']>;
};


export type QueryAllCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  tenant: Scalars['String']['input'];
};


export type QueryOrganizationTenantExistsArgs = {
  tenant: Scalars['String']['input'];
};

export type Question = Node & {
  __typename?: 'Question';
  _id: Scalars['ID']['output'];
  categories?: Maybe<Array<SanityBaseRef>>;
  maxTime?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<QuestionOptions>;
  rCategories?: Maybe<Array<Category>>;
  steps?: Maybe<Array<QuestionStep>>;
};

export type QuestionOptions = {
  __typename?: 'QuestionOptions';
  maxTime?: Maybe<Scalars['Int']['output']>;
};

export type QuestionStep = {
  __typename?: 'QuestionStep';
  _key: Scalars['String']['output'];
  answer?: Maybe<Answer>;
  question?: Maybe<Array<Scalars['JSONObject']['output']>>;
  score?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<QuestionStepType>;
};

export enum QuestionStepType {
  Hotzone = 'HOTZONE',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Numeric = 'NUMERIC',
  Practical = 'PRACTICAL',
  Text = 'TEXT'
}

export type RealtimeToken = {
  __typename?: 'RealtimeToken';
  capability: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  expires: Scalars['Float']['output'];
  issued: Scalars['Float']['output'];
  token: Scalars['String']['output'];
};

export type SanityArrayElement = {
  _key: Scalars['String']['output'];
};

export type SanityAssetRef = {
  __typename?: 'SanityAssetRef';
  _ref: Scalars['String']['output'];
  _type: Scalars['String']['output'];
};

export type SanityAssetRefInput = {
  _ref: Scalars['String']['input'];
  _type: Scalars['String']['input'];
};

export type SanityBaseRef = SanityReference & {
  __typename?: 'SanityBaseRef';
  _ref: Scalars['String']['output'];
  _type: Scalars['String']['output'];
};

export type SanityDocument = {
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
};

export type SanityImage = {
  __typename?: 'SanityImage';
  _type: Scalars['String']['output'];
  asset: SanityAssetRef;
};

export type SanityImageInput = {
  _type: Scalars['String']['input'];
  asset: SanityAssetRefInput;
};

export type SanityReference = {
  _ref: Scalars['String']['output'];
  _type: Scalars['String']['output'];
};

export type ScheduledSession = Node & SanityDocument & {
  __typename?: 'ScheduledSession';
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
  autoAdvance?: Maybe<Scalars['Boolean']['output']>;
  datetime?: Maybe<Scalars['String']['output']>;
  options?: Maybe<ScheduledSessionOptions>;
  progress?: Maybe<Scalars['String']['output']>;
  rLocation?: Maybe<Location>;
  rSession?: Maybe<Session>;
  status?: Maybe<ScheduledSessionStatus>;
  timeLeft?: Maybe<Scalars['Int']['output']>;
  unlockableParticipantIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ScheduledSessionOptions = {
  __typename?: 'ScheduledSessionOptions';
  allQuestionsInEvaluationShownByDefault?: Maybe<Scalars['Boolean']['output']>;
  enableAutoPauseOnHelpRequest?: Maybe<Scalars['Boolean']['output']>;
};

export type ScheduledSessionParticipantEntry = Node & SanityDocument & {
  __typename?: 'ScheduledSessionParticipantEntry';
  _createdAt: Scalars['String']['output'];
  _id: Scalars['ID']['output'];
  _rev: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  _updatedAt: Scalars['String']['output'];
  currentState?: Maybe<ScheduledSessionParticipantEntryCurrentState>;
  expectedEndTime?: Maybe<Scalars['String']['output']>;
  participant?: Maybe<SanityBaseRef>;
  ready?: Maybe<Scalars['Boolean']['output']>;
  reassignedEvaluationId?: Maybe<Scalars['ID']['output']>;
  sessionAnswers?: Maybe<Array<ScheduledSessionParticipantEntryAnswer>>;
  sessionOrder?: Maybe<Array<SanityBaseRef>>;
  sessionOverrides?: Maybe<Array<ScheduledSessionParticipantEntryOverride>>;
  sessionProgress?: Maybe<Array<ScheduledSessionParticipantEntryProgress>>;
  sessionStart?: Maybe<Scalars['String']['output']>;
  timeLeft?: Maybe<Scalars['Int']['output']>;
};

export type ScheduledSessionParticipantEntryAnswer = {
  __typename?: 'ScheduledSessionParticipantEntryAnswer';
  answers?: Maybe<Array<Answer>>;
  comment?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<SanityBaseRef>;
  question?: Maybe<SanityBaseRef>;
};

export type ScheduledSessionParticipantEntryCurrentState = {
  __typename?: 'ScheduledSessionParticipantEntryCurrentState';
  _type?: Maybe<Scalars['String']['output']>;
  correctedEvaluationIds?: Maybe<Array<Scalars['ID']['output']>>;
  evaluation?: Maybe<SanityBaseRef>;
  finishedEvaluationIds?: Maybe<Array<Scalars['ID']['output']>>;
  isCurrentEvaluationEnded?: Maybe<Scalars['Boolean']['output']>;
  isReassigned?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  latestProgress?: Maybe<ScheduledSessionParticipantEntryProgress>;
  progressPercentage?: Maybe<Scalars['Float']['output']>;
  question?: Maybe<SanityBaseRef>;
  rEvaluation?: Maybe<Evaluation>;
  rQuestion?: Maybe<Question>;
  reassignedWithUnsubmittedCorrectionsEvaluationIds?: Maybe<Array<Scalars['ID']['output']>>;
  status?: Maybe<ParticipantSessionStatus>;
  stepIndex?: Maybe<Scalars['Int']['output']>;
  totalEvaluationsCount?: Maybe<Scalars['Int']['output']>;
};

export type ScheduledSessionParticipantEntryOverride = {
  __typename?: 'ScheduledSessionParticipantEntryOverride';
  datetime?: Maybe<Scalars['String']['output']>;
  evaluation?: Maybe<SanityBaseRef>;
  overrideType?: Maybe<SessionOverrideType>;
  question?: Maybe<SanityBaseRef>;
  rEvaluation?: Maybe<Evaluation>;
  rQuestion?: Maybe<Question>;
  stepIndex?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<ScheduledSessionParticipantEntryOverrideValue>;
};

export type ScheduledSessionParticipantEntryOverrideValue = {
  __typename?: 'ScheduledSessionParticipantEntryOverrideValue';
  numericValue?: Maybe<Scalars['Float']['output']>;
  textValue?: Maybe<Scalars['String']['output']>;
};

export type ScheduledSessionParticipantEntryProgress = {
  __typename?: 'ScheduledSessionParticipantEntryProgress';
  evaluation?: Maybe<SanityBaseRef>;
  question?: Maybe<SanityBaseRef>;
  rEvaluation?: Maybe<Evaluation>;
  rQuestion?: Maybe<Question>;
  sectionEnd?: Maybe<Scalars['String']['output']>;
  sectionStart?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum ScheduledSessionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Open = 'OPEN',
  Paused = 'PAUSED'
}

export type SendErrorReportInput = {
  files: Array<Scalars['String']['input']>;
  message: Array<Scalars['JSONObject']['input']>;
  reportId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  user?: InputMaybe<SendErrorReportUser>;
};

export type SendErrorReportResponse = {
  __typename?: 'SendErrorReportResponse';
  success: Scalars['Boolean']['output'];
};

export type SendErrorReportUser = {
  email: Scalars['String']['input'];
  tenant: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  userType: UserType;
};

export type Session = Node & {
  __typename?: 'Session';
  _id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rCategories?: Maybe<Array<Category>>;
  rEvaluations?: Maybe<Array<Evaluation>>;
};

export enum SessionOverrideType {
  ExtendTime = 'EXTEND_TIME',
  HelpRequest = 'HELP_REQUEST',
  HelpRequestResolved = 'HELP_REQUEST_RESOLVED',
  OpenEvaluation = 'OPEN_EVALUATION',
  SessionPause = 'SESSION_PAUSE',
  SessionResume = 'SESSION_RESUME'
}

export type SessionReport = Node & {
  __typename?: 'SessionReport';
  _id: Scalars['ID']['output'];
  accessCode?: Maybe<Scalars['String']['output']>;
  cookies?: Maybe<Array<CookieValue>>;
};

export type SignupParticipantInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UserIdentifierInput = {
  type: UserIdentifierType;
  value: Scalars['String']['input'];
};

export enum UserIdentifierType {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export enum UserType {
  Admin = 'ADMIN',
  User = 'USER'
}

export type UserAddressFieldsFragment = { __typename?: 'Address', line1?: string | null, postal?: string | null, city?: string | null, region?: string | null, country?: string | null };

export type UserAnswerFieldsFragment = { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null };

export type UserCategoryFieldsFragment = { __typename?: 'Category', _id: string, name?: string | null };

export type UserCompanyFieldsFragment = { __typename?: 'Company', name?: string | null, _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

export type CookieValueFieldsFragment = { __typename?: 'CookieValue', name: string, value: string, expires?: string | null, secure?: boolean | null, sameSite?: string | null, path?: string | null };

export type UserEvaluationFieldsFragment = { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null };

export type UserLocationFieldsFragment = { __typename?: 'Location', _id: string, name?: string | null, address?: { __typename?: 'Address', line1?: string | null, postal?: string | null, city?: string | null, region?: string | null, country?: string | null } | null };

export type UserPageInfoFieldsFragment = { __typename?: 'PageInfo', totalCount?: number | null, pageSize?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null };

export type UserParticipantFieldsFragment = { __typename?: 'Participant', _id: string, name?: string | null, email?: string | null, phone?: string | null };

export type UserQuestionFieldsFragment = { __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null };

export type UserRealtimeTokenFieldsFragment = { __typename?: 'RealtimeToken', token: string, expires: number, issued: number, capability: string, clientId?: string | null };

type UserSanityDocumentFields_Company_Fragment = { __typename?: 'Company', _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

type UserSanityDocumentFields_Organization_Fragment = { __typename?: 'Organization', _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

type UserSanityDocumentFields_ScheduledSession_Fragment = { __typename?: 'ScheduledSession', _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

type UserSanityDocumentFields_ScheduledSessionParticipantEntry_Fragment = { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string };

export type UserSanityDocumentFieldsFragment = UserSanityDocumentFields_Company_Fragment | UserSanityDocumentFields_Organization_Fragment | UserSanityDocumentFields_ScheduledSession_Fragment | UserSanityDocumentFields_ScheduledSessionParticipantEntry_Fragment;

export type UserScheduledSessionFieldsFragment = { __typename?: 'ScheduledSession', _id: string, _rev: string, _type: string, _createdAt: string, _updatedAt: string, status?: ScheduledSessionStatus | null, datetime?: string | null, autoAdvance?: boolean | null, options?: { __typename?: 'ScheduledSessionOptions', allQuestionsInEvaluationShownByDefault?: boolean | null, enableAutoPauseOnHelpRequest?: boolean | null } | null, rSession?: { __typename?: 'Session', _id: string, name?: string | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, rEvaluations?: Array<{ __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null }> | null } | null, rLocation?: { __typename?: 'Location', _id: string, name?: string | null, address?: { __typename?: 'Address', line1?: string | null, postal?: string | null, city?: string | null, region?: string | null, country?: string | null } | null } | null };

export type UserScheduledSessionParticipantEntryFieldsFragment = { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null };

export type UserScheduledSessionParticipantEntryOverrideFieldsFragment = { __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null };

export type UserSessionFieldsFragment = { __typename?: 'Session', _id: string, name?: string | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, rEvaluations?: Array<{ __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null }> | null };

export type AnswerEvaluationQuestionStepMutationVariables = Exact<{
  evaluation: Scalars['ID']['input'];
  question: Scalars['ID']['input'];
  stepIndex: Scalars['Int']['input'];
  answer: AnswerInput;
}>;


export type AnswerEvaluationQuestionStepMutation = { __typename?: 'Mutation', answerEvaluationQuestionStep?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type CompleteAndCloseQuestionOrEvaluationMutationVariables = Exact<{
  evaluation: Scalars['ID']['input'];
  question?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CompleteAndCloseQuestionOrEvaluationMutation = { __typename?: 'Mutation', completeAndCloseQuestionOrEvaluation?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type CompleteOtpLoginMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
  loginCode: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type CompleteOtpLoginMutation = { __typename?: 'Mutation', completeOtpLogin?: { __typename?: 'CompleteOtpLoginResponse', success: boolean, cookies?: Array<{ __typename?: 'CookieValue', name: string, value: string, expires?: string | null, secure?: boolean | null, sameSite?: string | null, path?: string | null }> | null } | null };

export type CompleteSessionReportLoginMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  accessCode: Scalars['String']['input'];
}>;


export type CompleteSessionReportLoginMutation = { __typename?: 'Mutation', completeSessionReportLogin?: { __typename?: 'SessionReport', _id: string, accessCode?: string | null, cookies?: Array<{ __typename?: 'CookieValue', name: string, value: string, expires?: string | null, secure?: boolean | null, sameSite?: string | null, path?: string | null }> | null } | null };

export type ContinueSessionMutationVariables = Exact<{
  evaluation?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ContinueSessionMutation = { __typename?: 'Mutation', continueSession?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type GetRealtimeTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GetRealtimeTokenMutation = { __typename?: 'Mutation', getRealtimeToken?: { __typename?: 'RealtimeToken', token: string, expires: number, issued: number, capability: string, clientId?: string | null } | null };

export type LogoutParticipantMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutParticipantMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', success: boolean } };

export type ReadyScheduledSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadyScheduledSessionMutation = { __typename?: 'Mutation', readyScheduledSession?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type RequestCloudinaryUploadSignatureMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestCloudinaryUploadSignatureMutation = { __typename?: 'Mutation', requestCloudinaryUploadSignature?: { __typename?: 'CloudinaryUploadSignature', signature: string, timestamp: number, public_id: string } | null };

export type RequestHelpMutationVariables = Exact<{
  evaluation?: InputMaybe<Scalars['ID']['input']>;
  question?: InputMaybe<Scalars['ID']['input']>;
}>;


export type RequestHelpMutation = { __typename?: 'Mutation', requestHelp?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type RequestLoginMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
  loginCode: Scalars['String']['input'];
}>;


export type RequestLoginMutation = { __typename?: 'Mutation', requestLogin?: boolean | null };

export type SendErrorReportMutationVariables = Exact<{
  input: SendErrorReportInput;
}>;


export type SendErrorReportMutation = { __typename?: 'Mutation', sendErrorReport: { __typename?: 'SendErrorReportResponse', success: boolean } };

export type SignupForScheduledSessionMutationVariables = Exact<{
  tenant: Scalars['String']['input'];
  loginCode: Scalars['String']['input'];
  userIdentifier: UserIdentifierInput;
  participant: SignupParticipantInput;
}>;


export type SignupForScheduledSessionMutation = { __typename?: 'Mutation', signupForScheduledSession?: boolean | null };

export type AllCompaniesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['String']['input'];
}>;


export type AllCompaniesQuery = { __typename?: 'Query', allCompanies: { __typename?: 'CompanyConnection', pageInfo: { __typename?: 'PageInfo', totalCount?: number | null, pageSize?: number | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, startCursor?: string | null, endCursor?: string | null }, edges?: Array<{ __typename?: 'CompanyEdge', cursor: string, node: { __typename?: 'Company', name?: string | null, _id: string, _createdAt: string, _updatedAt: string, _type: string, _rev: string } }> | null } };

export type MyScheduledSessionParticipantEntryQueryVariables = Exact<{ [key: string]: never; }>;


export type MyScheduledSessionParticipantEntryQuery = { __typename?: 'Query', myScheduledSessionParticipantEntry?: { __typename?: 'ScheduledSessionParticipantEntry', _id: string, _rev: string, _type: string, _updatedAt: string, _createdAt: string, ready?: boolean | null, sessionStart?: string | null, reassignedEvaluationId?: string | null, timeLeft?: number | null, expectedEndTime?: string | null, currentState?: { __typename?: 'ScheduledSessionParticipantEntryCurrentState', status?: ParticipantSessionStatus | null, stepIndex?: number | null, lastUpdated?: string | null, isReassigned?: boolean | null, isCurrentEvaluationEnded?: boolean | null, finishedEvaluationIds?: Array<string> | null, totalEvaluationsCount?: number | null, progressPercentage?: number | null, correctedEvaluationIds?: Array<string> | null, reassignedWithUnsubmittedCorrectionsEvaluationIds?: Array<string> | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, rEvaluation?: { __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null } | null, latestProgress?: { __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null } | null } | null, participant?: { __typename?: 'SanityBaseRef', _ref: string } | null, sessionOrder?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, sessionAnswers?: Array<{ __typename?: 'ScheduledSessionParticipantEntryAnswer', comment?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, answers?: Array<{ __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null }> | null }> | null, sessionProgress?: Array<{ __typename?: 'ScheduledSessionParticipantEntryProgress', type?: string | null, timestamp?: string | null, sectionStart?: string | null, sectionEnd?: string | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null }> | null, sessionOverrides?: Array<{ __typename?: 'ScheduledSessionParticipantEntryOverride', datetime?: string | null, overrideType?: SessionOverrideType | null, evaluation?: { __typename?: 'SanityBaseRef', _ref: string } | null, question?: { __typename?: 'SanityBaseRef', _ref: string } | null, value?: { __typename?: 'ScheduledSessionParticipantEntryOverrideValue', numericValue?: number | null, textValue?: string | null } | null }> | null } | null };

export type MyScheduledSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type MyScheduledSessionQuery = { __typename?: 'Query', myScheduledSession?: { __typename?: 'ScheduledSession', _id: string, _rev: string, _type: string, _createdAt: string, _updatedAt: string, status?: ScheduledSessionStatus | null, datetime?: string | null, autoAdvance?: boolean | null, options?: { __typename?: 'ScheduledSessionOptions', allQuestionsInEvaluationShownByDefault?: boolean | null, enableAutoPauseOnHelpRequest?: boolean | null } | null, rSession?: { __typename?: 'Session', _id: string, name?: string | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, rEvaluations?: Array<{ __typename?: 'Evaluation', _id: string, name?: string | null, description?: string | null, totalMaxTime?: number | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, options?: { __typename?: 'EvaluationOptions', enableTimer?: boolean | null } | null, rQuestions?: Array<{ __typename?: 'Question', _id: string, name?: string | null, categories?: Array<{ __typename?: 'SanityBaseRef', _ref: string }> | null, rCategories?: Array<{ __typename?: 'Category', _id: string, name?: string | null }> | null, steps?: Array<{ __typename?: 'QuestionStep', type?: QuestionStepType | null, question?: Array<any> | null, answer?: { __typename?: 'Answer', textValue?: string | null, numericValue?: number | null, booleanValue?: boolean | null, textlistValue?: Array<string> | null, booleanlistValue?: Array<boolean> | null, numericlistValue?: Array<number> | null, blocklistValue?: Array<any> | null } | null }> | null, options?: { __typename?: 'QuestionOptions', maxTime?: number | null } | null }> | null }> | null } | null, rLocation?: { __typename?: 'Location', _id: string, name?: string | null, address?: { __typename?: 'Address', line1?: string | null, postal?: string | null, city?: string | null, region?: string | null, country?: string | null } | null } | null } | null };

export type OrganizationTenantExistsQueryVariables = Exact<{
  tenant: Scalars['String']['input'];
}>;


export type OrganizationTenantExistsQuery = { __typename?: 'Query', organizationTenantExists?: boolean | null };

export const UserSanityDocumentFieldsFragmentDoc = gql`
    fragment UserSanityDocumentFields on SanityDocument {
  _id
  _createdAt
  _updatedAt
  _type
  _rev
}
    `;
export const UserCompanyFieldsFragmentDoc = gql`
    fragment UserCompanyFields on Company {
  ...UserSanityDocumentFields
  name
}
    ${UserSanityDocumentFieldsFragmentDoc}`;
export const CookieValueFieldsFragmentDoc = gql`
    fragment CookieValueFields on CookieValue {
  name
  value
  expires
  secure
  sameSite
  path
}
    `;
export const UserPageInfoFieldsFragmentDoc = gql`
    fragment UserPageInfoFields on PageInfo {
  totalCount
  pageSize
  hasPreviousPage
  hasNextPage
  startCursor
  endCursor
}
    `;
export const UserParticipantFieldsFragmentDoc = gql`
    fragment UserParticipantFields on Participant {
  _id
  name
  email
  phone
}
    `;
export const UserRealtimeTokenFieldsFragmentDoc = gql`
    fragment UserRealtimeTokenFields on RealtimeToken {
  token
  expires
  issued
  capability
  clientId
}
    `;
export const UserCategoryFieldsFragmentDoc = gql`
    fragment UserCategoryFields on Category {
  _id
  name
}
    `;
export const UserAnswerFieldsFragmentDoc = gql`
    fragment UserAnswerFields on Answer {
  textValue
  numericValue
  booleanValue
  textlistValue
  booleanlistValue
  numericlistValue
  blocklistValue
}
    `;
export const UserQuestionFieldsFragmentDoc = gql`
    fragment UserQuestionFields on Question {
  _id
  name
  categories {
    _ref
  }
  rCategories {
    ...UserCategoryFields
  }
  steps {
    type
    question
    answer {
      ...UserAnswerFields
    }
  }
  options {
    maxTime
  }
}
    ${UserCategoryFieldsFragmentDoc}
${UserAnswerFieldsFragmentDoc}`;
export const UserEvaluationFieldsFragmentDoc = gql`
    fragment UserEvaluationFields on Evaluation {
  _id
  name
  description
  totalMaxTime
  categories {
    _ref
  }
  options {
    enableTimer
  }
  rQuestions {
    ...UserQuestionFields
  }
}
    ${UserQuestionFieldsFragmentDoc}`;
export const UserSessionFieldsFragmentDoc = gql`
    fragment UserSessionFields on Session {
  _id
  name
  rCategories {
    ...UserCategoryFields
  }
  rEvaluations {
    ...UserEvaluationFields
  }
}
    ${UserCategoryFieldsFragmentDoc}
${UserEvaluationFieldsFragmentDoc}`;
export const UserAddressFieldsFragmentDoc = gql`
    fragment UserAddressFields on Address {
  line1
  postal
  city
  region
  country
}
    `;
export const UserLocationFieldsFragmentDoc = gql`
    fragment UserLocationFields on Location {
  _id
  name
  address {
    ... on Address {
      ...UserAddressFields
    }
  }
}
    ${UserAddressFieldsFragmentDoc}`;
export const UserScheduledSessionFieldsFragmentDoc = gql`
    fragment UserScheduledSessionFields on ScheduledSession {
  _id
  _rev
  _type
  _createdAt
  _updatedAt
  status
  datetime
  options {
    allQuestionsInEvaluationShownByDefault
    enableAutoPauseOnHelpRequest
  }
  autoAdvance
  rSession {
    ...UserSessionFields
  }
  rLocation {
    ...UserLocationFields
  }
}
    ${UserSessionFieldsFragmentDoc}
${UserLocationFieldsFragmentDoc}`;
export const UserScheduledSessionParticipantEntryOverrideFieldsFragmentDoc = gql`
    fragment UserScheduledSessionParticipantEntryOverrideFields on ScheduledSessionParticipantEntryOverride {
  datetime
  overrideType
  evaluation {
    _ref
  }
  question {
    _ref
  }
  value {
    numericValue
    textValue
  }
}
    `;
export const UserScheduledSessionParticipantEntryFieldsFragmentDoc = gql`
    fragment UserScheduledSessionParticipantEntryFields on ScheduledSessionParticipantEntry {
  _id
  _rev
  _type
  _updatedAt
  _createdAt
  ready
  sessionStart
  currentState {
    status
    stepIndex
    evaluation {
      _ref
    }
    question {
      _ref
    }
    rEvaluation {
      ...UserEvaluationFields
    }
    lastUpdated
    isReassigned
    isCurrentEvaluationEnded
    finishedEvaluationIds
    totalEvaluationsCount
    progressPercentage
    latestProgress {
      type
      timestamp
      sectionStart
      sectionEnd
    }
    correctedEvaluationIds
    reassignedWithUnsubmittedCorrectionsEvaluationIds
  }
  participant {
    _ref
  }
  sessionOrder {
    _ref
  }
  sessionAnswers {
    evaluation {
      _ref
    }
    question {
      _ref
    }
    answers {
      ...UserAnswerFields
    }
    comment
  }
  sessionProgress {
    type
    evaluation {
      _ref
    }
    question {
      _ref
    }
    timestamp
    sectionStart
    sectionEnd
  }
  sessionOverrides {
    ...UserScheduledSessionParticipantEntryOverrideFields
  }
  reassignedEvaluationId
  timeLeft
  expectedEndTime
}
    ${UserEvaluationFieldsFragmentDoc}
${UserAnswerFieldsFragmentDoc}
${UserScheduledSessionParticipantEntryOverrideFieldsFragmentDoc}`;
export const AnswerEvaluationQuestionStepDocument = gql`
    mutation AnswerEvaluationQuestionStep($evaluation: ID!, $question: ID!, $stepIndex: Int!, $answer: AnswerInput!) {
  answerEvaluationQuestionStep(
    evaluation: $evaluation
    question: $question
    stepIndex: $stepIndex
    answer: $answer
  ) {
    ...UserScheduledSessionParticipantEntryFields
  }
}
    ${UserScheduledSessionParticipantEntryFieldsFragmentDoc}`;
export type AnswerEvaluationQuestionStepMutationFn = Apollo.MutationFunction<AnswerEvaluationQuestionStepMutation, AnswerEvaluationQuestionStepMutationVariables>;

/**
 * __useAnswerEvaluationQuestionStepMutation__
 *
 * To run a mutation, you first call `useAnswerEvaluationQuestionStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerEvaluationQuestionStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerEvaluationQuestionStepMutation, { data, loading, error }] = useAnswerEvaluationQuestionStepMutation({
 *   variables: {
 *      evaluation: // value for 'evaluation'
 *      question: // value for 'question'
 *      stepIndex: // value for 'stepIndex'
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useAnswerEvaluationQuestionStepMutation(baseOptions?: Apollo.MutationHookOptions<AnswerEvaluationQuestionStepMutation, AnswerEvaluationQuestionStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerEvaluationQuestionStepMutation, AnswerEvaluationQuestionStepMutationVariables>(AnswerEvaluationQuestionStepDocument, options);
      }
export type AnswerEvaluationQuestionStepMutationHookResult = ReturnType<typeof useAnswerEvaluationQuestionStepMutation>;
export type AnswerEvaluationQuestionStepMutationResult = Apollo.MutationResult<AnswerEvaluationQuestionStepMutation>;
export type AnswerEvaluationQuestionStepMutationOptions = Apollo.BaseMutationOptions<AnswerEvaluationQuestionStepMutation, AnswerEvaluationQuestionStepMutationVariables>;
export const CompleteAndCloseQuestionOrEvaluationDocument = gql`
    mutation CompleteAndCloseQuestionOrEvaluation($evaluation: ID!, $question: ID) {
  completeAndCloseQuestionOrEvaluation(
    evaluation: $evaluation
    question: $question
  ) {
    ...UserScheduledSessionParticipantEntryFields
  }
}
    ${UserScheduledSessionParticipantEntryFieldsFragmentDoc}`;
export type CompleteAndCloseQuestionOrEvaluationMutationFn = Apollo.MutationFunction<CompleteAndCloseQuestionOrEvaluationMutation, CompleteAndCloseQuestionOrEvaluationMutationVariables>;

/**
 * __useCompleteAndCloseQuestionOrEvaluationMutation__
 *
 * To run a mutation, you first call `useCompleteAndCloseQuestionOrEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAndCloseQuestionOrEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAndCloseQuestionOrEvaluationMutation, { data, loading, error }] = useCompleteAndCloseQuestionOrEvaluationMutation({
 *   variables: {
 *      evaluation: // value for 'evaluation'
 *      question: // value for 'question'
 *   },
 * });
 */
export function useCompleteAndCloseQuestionOrEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAndCloseQuestionOrEvaluationMutation, CompleteAndCloseQuestionOrEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteAndCloseQuestionOrEvaluationMutation, CompleteAndCloseQuestionOrEvaluationMutationVariables>(CompleteAndCloseQuestionOrEvaluationDocument, options);
      }
export type CompleteAndCloseQuestionOrEvaluationMutationHookResult = ReturnType<typeof useCompleteAndCloseQuestionOrEvaluationMutation>;
export type CompleteAndCloseQuestionOrEvaluationMutationResult = Apollo.MutationResult<CompleteAndCloseQuestionOrEvaluationMutation>;
export type CompleteAndCloseQuestionOrEvaluationMutationOptions = Apollo.BaseMutationOptions<CompleteAndCloseQuestionOrEvaluationMutation, CompleteAndCloseQuestionOrEvaluationMutationVariables>;
export const CompleteOtpLoginDocument = gql`
    mutation CompleteOtpLogin($tenant: String!, $userIdentifier: UserIdentifierInput!, $loginCode: String!, $otp: String!) {
  completeOtpLogin(
    tenant: $tenant
    userIdentifier: $userIdentifier
    loginCode: $loginCode
    otp: $otp
  ) {
    success
    cookies {
      ...CookieValueFields
    }
  }
}
    ${CookieValueFieldsFragmentDoc}`;
export type CompleteOtpLoginMutationFn = Apollo.MutationFunction<CompleteOtpLoginMutation, CompleteOtpLoginMutationVariables>;

/**
 * __useCompleteOtpLoginMutation__
 *
 * To run a mutation, you first call `useCompleteOtpLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOtpLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOtpLoginMutation, { data, loading, error }] = useCompleteOtpLoginMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      userIdentifier: // value for 'userIdentifier'
 *      loginCode: // value for 'loginCode'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useCompleteOtpLoginMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOtpLoginMutation, CompleteOtpLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOtpLoginMutation, CompleteOtpLoginMutationVariables>(CompleteOtpLoginDocument, options);
      }
export type CompleteOtpLoginMutationHookResult = ReturnType<typeof useCompleteOtpLoginMutation>;
export type CompleteOtpLoginMutationResult = Apollo.MutationResult<CompleteOtpLoginMutation>;
export type CompleteOtpLoginMutationOptions = Apollo.BaseMutationOptions<CompleteOtpLoginMutation, CompleteOtpLoginMutationVariables>;
export const CompleteSessionReportLoginDocument = gql`
    mutation CompleteSessionReportLogin($id: ID!, $accessCode: String!) {
  completeSessionReportLogin(id: $id, accessCode: $accessCode) {
    _id
    accessCode
    cookies {
      ...CookieValueFields
    }
  }
}
    ${CookieValueFieldsFragmentDoc}`;
export type CompleteSessionReportLoginMutationFn = Apollo.MutationFunction<CompleteSessionReportLoginMutation, CompleteSessionReportLoginMutationVariables>;

/**
 * __useCompleteSessionReportLoginMutation__
 *
 * To run a mutation, you first call `useCompleteSessionReportLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteSessionReportLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeSessionReportLoginMutation, { data, loading, error }] = useCompleteSessionReportLoginMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accessCode: // value for 'accessCode'
 *   },
 * });
 */
export function useCompleteSessionReportLoginMutation(baseOptions?: Apollo.MutationHookOptions<CompleteSessionReportLoginMutation, CompleteSessionReportLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteSessionReportLoginMutation, CompleteSessionReportLoginMutationVariables>(CompleteSessionReportLoginDocument, options);
      }
export type CompleteSessionReportLoginMutationHookResult = ReturnType<typeof useCompleteSessionReportLoginMutation>;
export type CompleteSessionReportLoginMutationResult = Apollo.MutationResult<CompleteSessionReportLoginMutation>;
export type CompleteSessionReportLoginMutationOptions = Apollo.BaseMutationOptions<CompleteSessionReportLoginMutation, CompleteSessionReportLoginMutationVariables>;
export const ContinueSessionDocument = gql`
    mutation ContinueSession($evaluation: ID) {
  continueSession(evaluation: $evaluation) {
    ...UserScheduledSessionParticipantEntryFields
  }
}
    ${UserScheduledSessionParticipantEntryFieldsFragmentDoc}`;
export type ContinueSessionMutationFn = Apollo.MutationFunction<ContinueSessionMutation, ContinueSessionMutationVariables>;

/**
 * __useContinueSessionMutation__
 *
 * To run a mutation, you first call `useContinueSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContinueSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [continueSessionMutation, { data, loading, error }] = useContinueSessionMutation({
 *   variables: {
 *      evaluation: // value for 'evaluation'
 *   },
 * });
 */
export function useContinueSessionMutation(baseOptions?: Apollo.MutationHookOptions<ContinueSessionMutation, ContinueSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContinueSessionMutation, ContinueSessionMutationVariables>(ContinueSessionDocument, options);
      }
export type ContinueSessionMutationHookResult = ReturnType<typeof useContinueSessionMutation>;
export type ContinueSessionMutationResult = Apollo.MutationResult<ContinueSessionMutation>;
export type ContinueSessionMutationOptions = Apollo.BaseMutationOptions<ContinueSessionMutation, ContinueSessionMutationVariables>;
export const GetRealtimeTokenDocument = gql`
    mutation GetRealtimeToken {
  getRealtimeToken {
    ...UserRealtimeTokenFields
  }
}
    ${UserRealtimeTokenFieldsFragmentDoc}`;
export type GetRealtimeTokenMutationFn = Apollo.MutationFunction<GetRealtimeTokenMutation, GetRealtimeTokenMutationVariables>;

/**
 * __useGetRealtimeTokenMutation__
 *
 * To run a mutation, you first call `useGetRealtimeTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRealtimeTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRealtimeTokenMutation, { data, loading, error }] = useGetRealtimeTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetRealtimeTokenMutation(baseOptions?: Apollo.MutationHookOptions<GetRealtimeTokenMutation, GetRealtimeTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetRealtimeTokenMutation, GetRealtimeTokenMutationVariables>(GetRealtimeTokenDocument, options);
      }
export type GetRealtimeTokenMutationHookResult = ReturnType<typeof useGetRealtimeTokenMutation>;
export type GetRealtimeTokenMutationResult = Apollo.MutationResult<GetRealtimeTokenMutation>;
export type GetRealtimeTokenMutationOptions = Apollo.BaseMutationOptions<GetRealtimeTokenMutation, GetRealtimeTokenMutationVariables>;
export const LogoutParticipantDocument = gql`
    mutation LogoutParticipant {
  logout {
    success
  }
}
    `;
export type LogoutParticipantMutationFn = Apollo.MutationFunction<LogoutParticipantMutation, LogoutParticipantMutationVariables>;

/**
 * __useLogoutParticipantMutation__
 *
 * To run a mutation, you first call `useLogoutParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutParticipantMutation, { data, loading, error }] = useLogoutParticipantMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutParticipantMutation(baseOptions?: Apollo.MutationHookOptions<LogoutParticipantMutation, LogoutParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutParticipantMutation, LogoutParticipantMutationVariables>(LogoutParticipantDocument, options);
      }
export type LogoutParticipantMutationHookResult = ReturnType<typeof useLogoutParticipantMutation>;
export type LogoutParticipantMutationResult = Apollo.MutationResult<LogoutParticipantMutation>;
export type LogoutParticipantMutationOptions = Apollo.BaseMutationOptions<LogoutParticipantMutation, LogoutParticipantMutationVariables>;
export const ReadyScheduledSessionDocument = gql`
    mutation ReadyScheduledSession {
  readyScheduledSession {
    ...UserScheduledSessionParticipantEntryFields
  }
}
    ${UserScheduledSessionParticipantEntryFieldsFragmentDoc}`;
export type ReadyScheduledSessionMutationFn = Apollo.MutationFunction<ReadyScheduledSessionMutation, ReadyScheduledSessionMutationVariables>;

/**
 * __useReadyScheduledSessionMutation__
 *
 * To run a mutation, you first call `useReadyScheduledSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadyScheduledSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readyScheduledSessionMutation, { data, loading, error }] = useReadyScheduledSessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadyScheduledSessionMutation(baseOptions?: Apollo.MutationHookOptions<ReadyScheduledSessionMutation, ReadyScheduledSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadyScheduledSessionMutation, ReadyScheduledSessionMutationVariables>(ReadyScheduledSessionDocument, options);
      }
export type ReadyScheduledSessionMutationHookResult = ReturnType<typeof useReadyScheduledSessionMutation>;
export type ReadyScheduledSessionMutationResult = Apollo.MutationResult<ReadyScheduledSessionMutation>;
export type ReadyScheduledSessionMutationOptions = Apollo.BaseMutationOptions<ReadyScheduledSessionMutation, ReadyScheduledSessionMutationVariables>;
export const RequestCloudinaryUploadSignatureDocument = gql`
    mutation RequestCloudinaryUploadSignature {
  requestCloudinaryUploadSignature {
    signature
    timestamp
    public_id
  }
}
    `;
export type RequestCloudinaryUploadSignatureMutationFn = Apollo.MutationFunction<RequestCloudinaryUploadSignatureMutation, RequestCloudinaryUploadSignatureMutationVariables>;

/**
 * __useRequestCloudinaryUploadSignatureMutation__
 *
 * To run a mutation, you first call `useRequestCloudinaryUploadSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestCloudinaryUploadSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestCloudinaryUploadSignatureMutation, { data, loading, error }] = useRequestCloudinaryUploadSignatureMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestCloudinaryUploadSignatureMutation(baseOptions?: Apollo.MutationHookOptions<RequestCloudinaryUploadSignatureMutation, RequestCloudinaryUploadSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestCloudinaryUploadSignatureMutation, RequestCloudinaryUploadSignatureMutationVariables>(RequestCloudinaryUploadSignatureDocument, options);
      }
export type RequestCloudinaryUploadSignatureMutationHookResult = ReturnType<typeof useRequestCloudinaryUploadSignatureMutation>;
export type RequestCloudinaryUploadSignatureMutationResult = Apollo.MutationResult<RequestCloudinaryUploadSignatureMutation>;
export type RequestCloudinaryUploadSignatureMutationOptions = Apollo.BaseMutationOptions<RequestCloudinaryUploadSignatureMutation, RequestCloudinaryUploadSignatureMutationVariables>;
export const RequestHelpDocument = gql`
    mutation RequestHelp($evaluation: ID, $question: ID) {
  requestHelp(evaluation: $evaluation, question: $question) {
    ...UserScheduledSessionParticipantEntryFields
  }
}
    ${UserScheduledSessionParticipantEntryFieldsFragmentDoc}`;
export type RequestHelpMutationFn = Apollo.MutationFunction<RequestHelpMutation, RequestHelpMutationVariables>;

/**
 * __useRequestHelpMutation__
 *
 * To run a mutation, you first call `useRequestHelpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestHelpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestHelpMutation, { data, loading, error }] = useRequestHelpMutation({
 *   variables: {
 *      evaluation: // value for 'evaluation'
 *      question: // value for 'question'
 *   },
 * });
 */
export function useRequestHelpMutation(baseOptions?: Apollo.MutationHookOptions<RequestHelpMutation, RequestHelpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestHelpMutation, RequestHelpMutationVariables>(RequestHelpDocument, options);
      }
export type RequestHelpMutationHookResult = ReturnType<typeof useRequestHelpMutation>;
export type RequestHelpMutationResult = Apollo.MutationResult<RequestHelpMutation>;
export type RequestHelpMutationOptions = Apollo.BaseMutationOptions<RequestHelpMutation, RequestHelpMutationVariables>;
export const RequestLoginDocument = gql`
    mutation RequestLogin($tenant: String!, $userIdentifier: UserIdentifierInput!, $loginCode: String!) {
  requestLogin(
    tenant: $tenant
    userIdentifier: $userIdentifier
    loginCode: $loginCode
  )
}
    `;
export type RequestLoginMutationFn = Apollo.MutationFunction<RequestLoginMutation, RequestLoginMutationVariables>;

/**
 * __useRequestLoginMutation__
 *
 * To run a mutation, you first call `useRequestLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestLoginMutation, { data, loading, error }] = useRequestLoginMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      userIdentifier: // value for 'userIdentifier'
 *      loginCode: // value for 'loginCode'
 *   },
 * });
 */
export function useRequestLoginMutation(baseOptions?: Apollo.MutationHookOptions<RequestLoginMutation, RequestLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestLoginMutation, RequestLoginMutationVariables>(RequestLoginDocument, options);
      }
export type RequestLoginMutationHookResult = ReturnType<typeof useRequestLoginMutation>;
export type RequestLoginMutationResult = Apollo.MutationResult<RequestLoginMutation>;
export type RequestLoginMutationOptions = Apollo.BaseMutationOptions<RequestLoginMutation, RequestLoginMutationVariables>;
export const SendErrorReportDocument = gql`
    mutation SendErrorReport($input: SendErrorReportInput!) {
  sendErrorReport(input: $input) {
    success
  }
}
    `;
export type SendErrorReportMutationFn = Apollo.MutationFunction<SendErrorReportMutation, SendErrorReportMutationVariables>;

/**
 * __useSendErrorReportMutation__
 *
 * To run a mutation, you first call `useSendErrorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendErrorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendErrorReportMutation, { data, loading, error }] = useSendErrorReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendErrorReportMutation(baseOptions?: Apollo.MutationHookOptions<SendErrorReportMutation, SendErrorReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendErrorReportMutation, SendErrorReportMutationVariables>(SendErrorReportDocument, options);
      }
export type SendErrorReportMutationHookResult = ReturnType<typeof useSendErrorReportMutation>;
export type SendErrorReportMutationResult = Apollo.MutationResult<SendErrorReportMutation>;
export type SendErrorReportMutationOptions = Apollo.BaseMutationOptions<SendErrorReportMutation, SendErrorReportMutationVariables>;
export const SignupForScheduledSessionDocument = gql`
    mutation SignupForScheduledSession($tenant: String!, $loginCode: String!, $userIdentifier: UserIdentifierInput!, $participant: SignupParticipantInput!) {
  signupForScheduledSession(
    tenant: $tenant
    loginCode: $loginCode
    userIdentifier: $userIdentifier
    participant: $participant
  )
}
    `;
export type SignupForScheduledSessionMutationFn = Apollo.MutationFunction<SignupForScheduledSessionMutation, SignupForScheduledSessionMutationVariables>;

/**
 * __useSignupForScheduledSessionMutation__
 *
 * To run a mutation, you first call `useSignupForScheduledSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupForScheduledSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupForScheduledSessionMutation, { data, loading, error }] = useSignupForScheduledSessionMutation({
 *   variables: {
 *      tenant: // value for 'tenant'
 *      loginCode: // value for 'loginCode'
 *      userIdentifier: // value for 'userIdentifier'
 *      participant: // value for 'participant'
 *   },
 * });
 */
export function useSignupForScheduledSessionMutation(baseOptions?: Apollo.MutationHookOptions<SignupForScheduledSessionMutation, SignupForScheduledSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupForScheduledSessionMutation, SignupForScheduledSessionMutationVariables>(SignupForScheduledSessionDocument, options);
      }
export type SignupForScheduledSessionMutationHookResult = ReturnType<typeof useSignupForScheduledSessionMutation>;
export type SignupForScheduledSessionMutationResult = Apollo.MutationResult<SignupForScheduledSessionMutation>;
export type SignupForScheduledSessionMutationOptions = Apollo.BaseMutationOptions<SignupForScheduledSessionMutation, SignupForScheduledSessionMutationVariables>;
export const AllCompaniesDocument = gql`
    query AllCompanies($first: Int, $after: String, $tenant: String!) {
  allCompanies(first: $first, after: $after, tenant: $tenant) {
    pageInfo {
      ...UserPageInfoFields
    }
    edges {
      cursor
      node {
        ...UserCompanyFields
      }
    }
  }
}
    ${UserPageInfoFieldsFragmentDoc}
${UserCompanyFieldsFragmentDoc}`;

/**
 * __useAllCompaniesQuery__
 *
 * To run a query within a React component, call `useAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useAllCompaniesQuery(baseOptions: Apollo.QueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables> & ({ variables: AllCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
      }
export function useAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
export function useAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
export type AllCompaniesQueryHookResult = ReturnType<typeof useAllCompaniesQuery>;
export type AllCompaniesLazyQueryHookResult = ReturnType<typeof useAllCompaniesLazyQuery>;
export type AllCompaniesSuspenseQueryHookResult = ReturnType<typeof useAllCompaniesSuspenseQuery>;
export type AllCompaniesQueryResult = Apollo.QueryResult<AllCompaniesQuery, AllCompaniesQueryVariables>;
export const MyScheduledSessionParticipantEntryDocument = gql`
    query MyScheduledSessionParticipantEntry {
  myScheduledSessionParticipantEntry {
    ...UserScheduledSessionParticipantEntryFields
  }
}
    ${UserScheduledSessionParticipantEntryFieldsFragmentDoc}`;

/**
 * __useMyScheduledSessionParticipantEntryQuery__
 *
 * To run a query within a React component, call `useMyScheduledSessionParticipantEntryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyScheduledSessionParticipantEntryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyScheduledSessionParticipantEntryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyScheduledSessionParticipantEntryQuery(baseOptions?: Apollo.QueryHookOptions<MyScheduledSessionParticipantEntryQuery, MyScheduledSessionParticipantEntryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyScheduledSessionParticipantEntryQuery, MyScheduledSessionParticipantEntryQueryVariables>(MyScheduledSessionParticipantEntryDocument, options);
      }
export function useMyScheduledSessionParticipantEntryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyScheduledSessionParticipantEntryQuery, MyScheduledSessionParticipantEntryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyScheduledSessionParticipantEntryQuery, MyScheduledSessionParticipantEntryQueryVariables>(MyScheduledSessionParticipantEntryDocument, options);
        }
export function useMyScheduledSessionParticipantEntrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyScheduledSessionParticipantEntryQuery, MyScheduledSessionParticipantEntryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyScheduledSessionParticipantEntryQuery, MyScheduledSessionParticipantEntryQueryVariables>(MyScheduledSessionParticipantEntryDocument, options);
        }
export type MyScheduledSessionParticipantEntryQueryHookResult = ReturnType<typeof useMyScheduledSessionParticipantEntryQuery>;
export type MyScheduledSessionParticipantEntryLazyQueryHookResult = ReturnType<typeof useMyScheduledSessionParticipantEntryLazyQuery>;
export type MyScheduledSessionParticipantEntrySuspenseQueryHookResult = ReturnType<typeof useMyScheduledSessionParticipantEntrySuspenseQuery>;
export type MyScheduledSessionParticipantEntryQueryResult = Apollo.QueryResult<MyScheduledSessionParticipantEntryQuery, MyScheduledSessionParticipantEntryQueryVariables>;
export const MyScheduledSessionDocument = gql`
    query MyScheduledSession {
  myScheduledSession {
    ...UserScheduledSessionFields
  }
}
    ${UserScheduledSessionFieldsFragmentDoc}`;

/**
 * __useMyScheduledSessionQuery__
 *
 * To run a query within a React component, call `useMyScheduledSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyScheduledSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyScheduledSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyScheduledSessionQuery(baseOptions?: Apollo.QueryHookOptions<MyScheduledSessionQuery, MyScheduledSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyScheduledSessionQuery, MyScheduledSessionQueryVariables>(MyScheduledSessionDocument, options);
      }
export function useMyScheduledSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyScheduledSessionQuery, MyScheduledSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyScheduledSessionQuery, MyScheduledSessionQueryVariables>(MyScheduledSessionDocument, options);
        }
export function useMyScheduledSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyScheduledSessionQuery, MyScheduledSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyScheduledSessionQuery, MyScheduledSessionQueryVariables>(MyScheduledSessionDocument, options);
        }
export type MyScheduledSessionQueryHookResult = ReturnType<typeof useMyScheduledSessionQuery>;
export type MyScheduledSessionLazyQueryHookResult = ReturnType<typeof useMyScheduledSessionLazyQuery>;
export type MyScheduledSessionSuspenseQueryHookResult = ReturnType<typeof useMyScheduledSessionSuspenseQuery>;
export type MyScheduledSessionQueryResult = Apollo.QueryResult<MyScheduledSessionQuery, MyScheduledSessionQueryVariables>;
export const OrganizationTenantExistsDocument = gql`
    query OrganizationTenantExists($tenant: String!) {
  organizationTenantExists(tenant: $tenant)
}
    `;

/**
 * __useOrganizationTenantExistsQuery__
 *
 * To run a query within a React component, call `useOrganizationTenantExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTenantExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTenantExistsQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useOrganizationTenantExistsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationTenantExistsQuery, OrganizationTenantExistsQueryVariables> & ({ variables: OrganizationTenantExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationTenantExistsQuery, OrganizationTenantExistsQueryVariables>(OrganizationTenantExistsDocument, options);
      }
export function useOrganizationTenantExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationTenantExistsQuery, OrganizationTenantExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationTenantExistsQuery, OrganizationTenantExistsQueryVariables>(OrganizationTenantExistsDocument, options);
        }
export function useOrganizationTenantExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationTenantExistsQuery, OrganizationTenantExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationTenantExistsQuery, OrganizationTenantExistsQueryVariables>(OrganizationTenantExistsDocument, options);
        }
export type OrganizationTenantExistsQueryHookResult = ReturnType<typeof useOrganizationTenantExistsQuery>;
export type OrganizationTenantExistsLazyQueryHookResult = ReturnType<typeof useOrganizationTenantExistsLazyQuery>;
export type OrganizationTenantExistsSuspenseQueryHookResult = ReturnType<typeof useOrganizationTenantExistsSuspenseQuery>;
export type OrganizationTenantExistsQueryResult = Apollo.QueryResult<OrganizationTenantExistsQuery, OrganizationTenantExistsQueryVariables>;